const financialInput={
    "fiscalInputId": 0,
    "reportDate": new Date(),
    "companyName": '',
    "division": null,
    "fiscalStart": new Date(),
    "fiscalEnd": new Date(),
    "companyId": 0,
    "isYTD": false,
    "budgetedRevenue": 0,
    "budgetedCOGS": 0,
    "budgetedOverhead": 0,
    "budgetedAccrual": 0,
    "budgetedAdjustmentsToNet": 0,
    "budgetedESOP": 0,
    "budgetedTaxes": 0,
    "budgetedPPP": 0,
    "budgetedERC": 0,
    "budgetedMargin": 0,
    "budgetedNetBeforeTax": 0,
    "budgetedFiscalNet": 0,
    "actualRevenue": 0,
    "actualCOGS": 0,
    "actualAccruals": 0,
    "actualAdjustmentsToNet": 0,
    "actualESOP": 0,
    "actualTaxes": 0,
    "actualPPP": 0,
    "actualERC": 0,
    "actualOverhead": 0,
    "actualMargin": 0,
    "actualNetBeforeTax": 0,
    "actualNetAfterTax": 0,
    "cashBalance": 0,
    "cashLineCapacity": 0,
    "cashLineBalance": 0,
    "cashAssets": 0,
    "cashAP": 0,
    "cashAPRetention": 0,
    "cashAR": 0,
    "cashARRetention": 0,
    "cashAROverdue": 0,
    "cashOverbilling": 0,
    "cashUnderbilling": 0,
    "cashChangeOrdersCost": 0,
    "cashTotalAP": 0,
    "cashTotalAR": 0,
    "cashDSO": 0,
    "cashDemand": 0,
    "cashDemandDays": 0,
    "cashNetBillings": 0,
    "backlogBurn": 0,
    "backlogBurnFuture": 0,
    "backlogBurnMargin": 0,
    "backlogBurnFutureMargin": 0,
    "backlogSold": 0,
    "backlogPotential": 0,
    "backlogTotalRevenue": 0,
    "backlogTotalMargin": 0,
    "staffFieldCount": 0,
    "staffOfficeCount": 0,
    "staffRevenuePerManhour": 0,
    "staffMaterialPerManhour": 0,
    "staffEstimatingDollar": 0,
    "staffEstimatingCount": 0,
    "staffEMR": 0,
    "staffWorkersComp": 0,
    "staffRatio": "0:0",
    "staffRevenuePerOffice": 0,
    "staffGrossMarginPerOffice": 0,
    "staffRevenuePerField": 0,
    "staffGrossMarginPerField": 0,
    "performanceCurrentAssets": 0,
    "performanceTotalAssets": 0,
    "performanceCurrentLiabilities": 0,
    "performanceTotalLiabilities": 0,
    "performanceEquity": 0,
    "performanceCurrentRatio": 0,
    "performanceQuickRatio": 0,
    "performanceRScore": 0,
    "performanceWorkingCapital": 0,
    "wipBilled": 0,
    "wipCost": 0,
    "wipLabor": 0,
    "wipLaborProductivity": 0,
    "daysElapsed": 365,
    "percentBudgetedCogs": 0,
    "percentBudgetedMargin": 0,
    "percentBudgetedOverhead": 0,
    "percentBudgetedNetPreTax": 0,
    "percentActualCOGS": 0,
    "percentActualMargin": 0,
    "percentActualOverhead": 0,
    "percentActualAdjustments": 0,
    "percentActualNet": 0,
    "percentDaysElapsed": 100,
    "percentCashLineBalance": 0,
    "percentCashAR": 0,
    "percentCashAROverdue": 0,
    "percentCashOverbillings": 0,
    "percentCashUnderbilling": 0,
    "percentCashChangeOrderCost": 0,
    "peerGroupId": 0
};

export default financialInput;